import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Bg from 'assets/img/screenType2/bg.png'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'

import Slider, { Settings } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ArrowLeft from 'assets/img/main/arrowLeft.svg'
import ArrowRight from 'assets/img/main/arrowRight.svg'

import { useSpring, animated } from '@react-spring/web'
import { useNavigate } from 'react-router-dom'

import Tocuh from 'assets/img/sps/touch.png'

const Container = styled.div`
	position: relative;
	width: 1920px;
	height: 1080px;
	background-image: url(${Bg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	.slideImage {
		max-width: 1920px;
		max-height: 1080px;
	}
`

const NextArrowContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 50px;
	width: 43px;
	height: 85px;
	z-index: 1;
	&::before {
		content: url(${ArrowRight});
		width: 43px;
		height: 85px;
	}
`
const PrevArrowContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 50px;
	width: 43px;
	height: 85px;
	z-index: 1;
	&::before {
		content: url(${ArrowLeft});
		width: 43px;
		height: 85px;
	}
`

const RippleOut = styled.div`
	position: absolute;
	width: 140px;
	height: 140px;
	border-radius: 50%;
	bottom: 20%;
	left: 50%;
	transform: translateX(-50%);
	&::before,
	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		border: 5px solid #ffffff;
		border-radius: 50%;
	}
	&:before {
		animation: ripple 2s linear infinite;
	}
	&:after {
		animation: ripple 2s linear 1s infinite;
	}
	@keyframes ripple {
		0% {
			transform: scale(1);
			opacity: 0.2;
		}
		50% {
			transform: scale(1.3);
			opacity: 0.8;
		}
		100% {
			transform: scale(1.6);
			opacity: 0;
		}
	}
	.txt {
		height: 140px;
		width: 140px;
		text-align: center;
		color: rgba(0, 0, 0, 0.3);
		font-size: 25px;
		font-weight: bold;
		background: url(${Tocuh}) no-repeat center center;
		border-radius: 50%;
		position: relative;
		mix-blend-mode: hue;
	}
`

const Row = styled.div`
	display: flex;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	.item {
		position: relative;
		width: 33.333333%;
		height: 1080px;
		.rippleItem {
			opacity: 0;
			animation: fadeInOut 15s infinite;
		}
		&:nth-child(1) .rippleItem {
			animation-delay: 0s;
		}
		&:nth-child(2) .rippleItem {
			animation-delay: 5s;
		}
		&:nth-child(3) .rippleItem {
			animation-delay: 10s;
		}
	}
	@keyframes fadeInOut {
		0% {
			opacity: 0;
		}
		10% {
			opacity: 1;
		}
		40% {
			opacity: 0;
		}
		100% {
			opacity: 0;
		}
	}
`

/**
 * SPS 화면
 * @param param0
 * @returns
 */
const ScreenType3 = ({ menuList, visualList, spsImageList }: any) => {
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [hoverActive, setHoverActive] = useState(false)

	const menuMove = useSpring({
		from: { y: 100, opacity: 0 },
		to: { y: 0, opacity: 1 },
		delay: 300,
	})

	// const touchMove = useSpring({
	// 	from: { opacity: 0, scale: 0.5 },
	// 	to: { opacity: 1, scale: 1 },
	// 	delay: 200,
	// 	reverse: reversed, // Reverse the animation
	// 	onRest: () => setReversed(!reversed), // Toggle reversed when the animation finishes
	// })

	const NextArrow = (props: any) => {
		const { className, style, onClick } = props
		return (
			<NextArrowContainer
				className={className}
				style={{ ...style }}
				onClick={onClick}
			/>
		)
	}

	const PrevArrow = (props: any) => {
		const { className, style, onClick } = props
		return (
			<PrevArrowContainer
				className={className}
				style={{ ...style }}
				onClick={onClick}
			/>
		)
	}

	const sliderRef = useRef<Slider | null>(null)
	const [currentSlide, setCurrentSlide] = useState<number>(0)
	const videoRef = useRef<HTMLVideoElement>(null)

	const settings = {
		dots: false,
		infinite: true,
		arrows: true,
		speed: 300,
		fade: true,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		beforeChange: (current: number, next: number) => setCurrentSlide(next),
		afterChange: (current: number) => onItemChanged(current),
	}

	const onItemChanged = (current: number) => {
		// if current slide is video/mp4 then play the video and stop autoplay
		const currentSlide = visualList[current]
		// console.log(currentSlide.fileMime)
		// if (
		//     currentSlide.fileMime === 'video/mp4' ||
		//     currentSlide.fileMime === 'video/quicktime'
		// ) {
		//     sliderRef.current?.slickPause()
		//     const video = videoRef.current
		//     if (video) {
		//         video.src =
		//             `${process.env.REACT_APP_HOST}/video/view/` +
		//             visualList[current]?.fileName
		//         video.load()
		//         video.currentTime = 0
		//         video.play()
		//     }
		// } else {
		//     sliderRef.current?.slickPlay()
		// }
		sliderRef.current?.slickPlay()
	}

	const handleVideoEnded = () => {
		const video = videoRef.current
		if (video) {
			video.pause()
			video.currentTime = 0
		}
		setTimeout(() => {
			sliderRef.current?.slickNext()
		}, 300)
	}

	const movePage = (item: any) => {
		console.log(item)
		navigate('/sps/list', { state: { menuList } })
	}

	useEffect(() => {
		if (deviceInfo.branchCd && deviceInfo.kioskName) {
			setTimeout(() => {
				setHoverActive(!hoverActive)
			}, 5000)
		}
		console.log('menuList')
		console.log(menuList)
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [hoverActive])

	return (
		<Container>
			<animated.div style={{ ...menuMove }}>
				<Slider
					ref={sliderRef}
					{...settings}
				>
					{/* {visualList.map((item: any, index: number) => {
                        return (
                            <li
                                key={item.fileId}
                                onClick={() => movePage(item)}
                            >
                                {item.fileMime === 'video/mp4' ||
                                item.fileMime === 'video/quicktime' ? (
                                    <video
                                        width="100%"
                                        height="100%"
                                        muted
                                        onEnded={handleVideoEnded}
                                        id={'video_' + index}
                                        ref={videoRef}
                                    >
                                        <source
                                            src={
                                                `${process.env.REACT_APP_HOST}/video/view/${item.fileName}` ||
                                                ''
                                            }
                                            type={item.fileMime}
                                        />
                                    </video>
                                ) : (
                                    <img
                                        src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
                                        alt=""
                                        style={{ maxWidth: '100%' }}
                                        loading="lazy"
                                    />
                                )}
                            </li>
                        )
                    })} */}
					{spsImageList.map((item: any, index: number) => (
						<div
							className="imgContainer"
							key={item.fileId}
							onClick={() => movePage(item)}
						>
							<img
								src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
								alt=""
								className="slideImage"
								loading="lazy"
							/>
						</div>
					))}
				</Slider>
			</animated.div>
			<Row onClick={() => movePage({})}>
				<div className="item">
					<RippleOut className="rippleItem">
						<div className="txt"></div>
					</RippleOut>
				</div>
				<div className="item">
					<RippleOut className="rippleItem">
						<div className="txt"></div>
					</RippleOut>
				</div>
				<div className="item">
					<RippleOut className="rippleItem">
						<div className="txt"></div>
					</RippleOut>
				</div>
			</Row>
		</Container>
	)
}

export default ScreenType3
